module.exports = __webpack_public_path__ + "img/icon-tag.fbc07d2b.svg";